import React, { useState, useEffect } from "react";
import { Row, Col, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  setUserPermissionsIsEdit,
  updateUserPermissions,
  updateUserSettings,
} from "../redux/actions";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import SpinnerComponent from "../../../components/spinner";
import PermissionsSection from "./permissionsSection";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";

const GeneralPermissions = ({ isProfileCase, canUpdate }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    popupNotifications: false,
    emailNotifications: false,
  });

  const [upperPermissions, setUpperPermissions] = useState({
    labs_setup: {
      add_edit: false,
      view: false,
      export: false,
      delete: false,
    },
  });

  const [state, setState] = useState({
    user_manager: { add_edit: false, view: false, delete: false },
    departments: { add_edit: false, view: false, delete: false },
    variance_statuses: { add_edit: false, view: false, delete: false },
    lab_statuses: { add_edit: false, view: false, delete: false },
  });
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();

  const {
    currentUserObj,
    popupLoading,
    emailLoading,
    permissionsLoading,
    userPermissionsIsEdit,
  } = useSelector((state) => state.userManagerReducer);

  useEffect(() => {
    if (currentUserObj?.id > 0) {
      const { popupNotifications, emailNotifications, permissions } = currentUserObj;
      setData({
        popupNotifications,
        emailNotifications,
      });

      if (permissions !== null) {
        // Define which permissions should go to the state
        const {
          labs_setup,
          user_manager,
          departments,
          variance_statuses,
          lab_statuses,
          ...rest
        } = permissions;

        // Only set the permissions that belong in the state
        setState({
          user_manager: user_manager || { add_edit: false, view: false, delete: false },
          departments: departments || { add_edit: false, view: false, delete: false },
          variance_statuses: variance_statuses || { add_edit: false, view: false, delete: false },
          lab_statuses: lab_statuses || { add_edit: false, view: false, delete: false },
        });

        // Only set labs_setup in upperPermissions
        if (labs_setup) {
          setUpperPermissions({
            labs_setup: {
              add_edit: labs_setup.add_edit || false,
              view: labs_setup.view || false,
              export: labs_setup.export || false,
              delete: labs_setup.delete || false,
            }
          });
        }
      }
    } else if (currentUserObj?.id === 0) {
      // For new users, ensure permissions are initialized with default values
      dispatch(setUserPermissionsIsEdit(true));
    }
  }, [currentUserObj, dispatch]);

  const handleSave = () => {
    dispatch(
      updateUserPermissions({
        permissions: { ...upperPermissions, ...state },
        id: currentUserObj?.id,
      })
    );
  };

  const onChangeNotification = (key, checked, loadingObj) => {
    setData({ ...data, [key]: checked });
    const { id } = currentUserObj;
    dispatch(
      updateUserSettings({
        data: { id, [key]: checked },
        loadingObj,
      })
    );
  };

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span user-details-heading">General Permissions</span>
              </div>
            </Col>
            {/* {!isProfileCase && canEditEveryThing && ( */}
            <Col>
              {userPermissionsIsEdit ? (
                permissionsLoading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon className="save-icon" width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill="#ed017f"
                    height={16}
                    onClick={() => dispatch(setUserPermissionsIsEdit(true))}
                  />
                )
              )}
            </Col>
            {/* )} */}
          </Row>
        </Col>
        <PermissionsSection
          state={state}
          setState={setState}
          upperPermissions={upperPermissions}
          setUpperPermissions={setUpperPermissions}
          readOnly={userPermissionsIsEdit}
        />

        {/* Remove the General Permissions Notifications section and bring up Lab Permissions to close up the gap. */}
        {/* <Col span={24} className="section-body settings-section">
          <Row
            align="middle"
            justify="space-between"
            className="simple-heading-col"
          >
            <Col md={23} lg={23} xl={23} xxl={23}>
              <div>
                <span className="heading-span">
                  General Permissions Notifications
                </span>
              </div>
            </Col>
          </Row>
          <Row style={{ paddingLeft: "12px" }}>
            <Col md={0} lg={2} xl={1} xxl={1}></Col>
            <Col md={8} lg={6} xl={4} xxl={4}>
              <div className="heading-text">Browser notifications</div>
              <div className="switch-parent-div">
                <span className={`${!data.popupNotifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  checked={data.popupNotifications}
                  disabled={(currentUserObj?.id ? false : true) || popupLoading}
                  onChange={(e) =>
                    onChangeNotification("popupNotifications", e, {
                      popupLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.popupNotifications && "on"}`}>
                  On
                </span>
              </div>
            </Col>
            <Col>
              <div className="heading-text">Email notifications</div>
              <div className={"switch-parent-div"}>
                <span className={`${!data.emailNotifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  disabled={(currentUserObj?.id ? false : true) || emailLoading}
                  checked={data.emailNotifications}
                  onChange={(e) =>
                    onChangeNotification("emailNotifications", e, {
                      emailLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.emailNotifications && "on"}`}>
                  On
                </span>
              </div>
            </Col>
          </Row>
        </Col> */}
      </Row>
    </>
  );
};
export default GeneralPermissions;
